/*@flow*/
import type { RefinementType } from './types.js'; import mkInteger from './mkInteger';

export default (mkInteger(): RefinementType);
